// Croqui: `components/Notice.tsx`.
//
// WEB-133: o mesmo desenho do `components/app/notice.tsx`: superfície NEUTRA em todo tom e
// um quadrado pequeno de cor dizendo o estado. Sem borda colorida, sem ícone tingido.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { Card } from './card.tsx';
import type { IconName } from './icon.tsx';
import type { Tone } from './ink.ts';

const MARK: Record<Tone, string> = {
  ok: 'bg-green',
  wait: 'bg-warning',
  bad: 'bg-danger',
  neutral: 'bg-muted-foreground',
  info: 'bg-muted-foreground',
  attention: 'bg-attention',
};

/** Aviso inline. Tom seco: motivo, prazo, o que fazer. */
export function Notice({
  tone = 'wait',
  title,
  children,
  action,
  className,
}: {
  tone?: Tone;
  /** Aceito por compatibilidade e NÃO desenhado: a marca do aviso é o quadrado do tom. */
  icon?: IconName;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <Card className={cn('flex items-start gap-3 rounded-xl px-4 py-3', className)}>
      <span aria-hidden="true" className={cn('mt-1.5 size-2 shrink-0', MARK[tone])} />
      <div className="min-w-0 flex-1">
        <div className="text-14 leading-snug font-medium">{title}</div>
        {children !== undefined && (
          <div className="mt-0.5 text-12 text-muted leading-relaxed tabular-nums">{children}</div>
        )}
      </div>
      {action}
    </Card>
  );
}
